import React from 'react';
import PropTypes from 'prop-types';

import { Headline as HeadlineXdl } from '@xingternal/typography';

const sizes = ['xxlarge', 'xlarge', 'large', 'medium', 'small'];

const Headline = ({ className, level, levelConfined, levelWide, ...props }) => {
  const oldProps = {
    size: sizes[level - 1] || 'xlarge',
    sizeConfined: sizes[levelConfined - 1],
    sizeWide: sizes[levelWide - 1],
  };

  const headlineProps = {
    ...props,
    ...oldProps,
    className,
  };
  return <HeadlineXdl {...headlineProps} />;
};

Headline.displayName = 'Headline';

Headline.propTypes = {
  /** define the level of the Headline */
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** define the level of the Headline in tablet sizes */
  levelConfined: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** define the level for Headline in large screens   */
  levelWide: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** add a custom className to the component */
  className: PropTypes.string,
  /** set the elements margin to 0 */
  noMargin: PropTypes.bool,
  /** insert the headline text */
  children: PropTypes.node.isRequired,
  /** define a testid for the paragraph */
  testId: PropTypes.string,
};

export default Headline;
